import { any, both, complement, curry, not, props } from 'ramda'
import { isNumber } from './type'

export const anyProp = curry((fn, propNames, object) =>
  any(fn, props(propNames, object)),
)

export const anyPropMissing = curry(anyProp(both(complement(isNumber), not)))

export const notEmptyOrFalsy = (val: any): boolean => {
  return (
    Boolean(val) &&
    (Array.isArray(val) || typeof val === 'string' ? val.length > 0 : true)
  )
}
